export const TRANSLATION_GROUP_PLAYER_TRACKER = Symbol('admin-players.player-tracking');
export const PLAYER_TRACKER_ROUTE = Symbol('player_tracker');
